module.exports = __webpack_public_path__ + "img/title-bg.cd5e0b8d.png";